// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"B_R","menu":"B_S"};